var _defs, _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gruppe_2408",
    "data-name": "Gruppe 2408",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-6767 -701 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #000;\n        stroke-linejoin: round;\n        stroke-miterlimit: 10;\n        stroke-width: 1.5px;\n      }\n\n      .cls-2 {\n        stroke-linecap: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2404",
    "data-name": "Gruppe 2404",
    transform: "translate(-6771 -711.3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_92",
    "data-name": "Rechteck 92",
    className: "cls-1",
    width: 6.4,
    height: 11.2,
    transform: "translate(16 47.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_159",
    "data-name": "Pfad 159",
    className: "cls-2",
    d: "M22.4,57.5H49.6c0-2.4-5.6-4.8-12-4.8H26.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_160",
    "data-name": "Pfad 160",
    className: "cls-1",
    d: "M22.4,49.5H28a8.235,8.235,0,0,1,6.4,3.2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_350",
    "data-name": "Gruppe 350"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    className: "cls-1",
    cx: 4.8,
    cy: 4.8,
    r: 4.8,
    transform: "translate(35.2 30.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_161",
    "data-name": "Pfad 161",
    className: "cls-1",
    d: "M50.4,35.1a16.352,16.352,0,0,0-.2-2.2l2.5-1.5-3.2-5.5L47,27.4a9.133,9.133,0,0,0-3.7-2.2V22.3H36.9v2.9a9.526,9.526,0,0,0-3.8,2.2l-2.6-1.5-3.2,5.5,2.5,1.5a14.979,14.979,0,0,0-.2,2.2,16.352,16.352,0,0,0,.2,2.2l-2.5,1.5,3.2,5.5,2.6-1.5A9.526,9.526,0,0,0,36.9,45v2.9h6.4V45A9.133,9.133,0,0,0,47,42.8l2.5,1.5,3.2-5.5-2.5-1.5A17.96,17.96,0,0,0,50.4,35.1Z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1325",
    "data-name": "Rechteck 1325",
    className: "cls-3",
    width: 60,
    height: 60,
    transform: "translate(-6767 -701)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter3);
export default __webpack_public_path__ + "static/media/filter3.5a5129f220fc1ac028b12a4fdff8b3a5.svg";
export { ForwardRef as ReactComponent };